<template>
    <div>
        <div>
            <a-dropdown @click.prevent>
                <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                    {{ email }}
                    <a-icon type="caret-down" />
                </a-button>
                <a-menu style="max-height: 400px; overflow-y: auto" slot="overlay">
                    <a-menu-item 
                        v-for="(user, index) in users" 
                        :key="`${user.userId}-${index}`" 
                        @click="select(user)"
                        style="text-transform: none !important;">
                            {{user.email}}
                    </a-menu-item>
                </a-menu>
            </a-dropdown>
        </div>
        <div class="mt-4 table-holder">
            <table class="table">
                <thead class="thead-dark">
                    <tr>
                        <th class="text-center">No</th>
                        <th class="text-center">Camp Title</th>
                        <th class="text-center">Author Id</th>
                        <th class="text-center">Author Email</th>
                        <th class="text-center">Added Date</th>
                        <th class="text-center">Activate</th>
                    </tr>
                </thead>
                <tbody>
                    <TableRow
                        v-for="campaign in filterUsers" 
                        :key="`campaign-${campaign.id}`"
                        :campaign="campaign"/>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { db, ADMINS } from '../../../firebase'
import TableRow from './TableRow'

export default {
    name: 'DraftsPanel',
    components: {
        TableRow,
    },
    data() {
        return {
            campaigns: [],
            users: [],
            emails: {},
            email: 'All',
            userId: null,
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
        filterUsers: function() {
            if(this.email === 'All') {
                return this.campaigns
            }

            return this.campaigns.filter(
                (m) => m.author_id === this.userId
            )
        }
    },
    mounted: function() {
        if(ADMINS.includes(this.user.uid)) {
            this.getUsers()
            return
        }
        return this.$router.push('/').catch(()=>{})
    },
    methods: {
        getUsers: function() {
            db
                .collection('Users')
                .get()
                .then(user => {
                    this.users = user.docs.map(
                        (doc) => {
                            return {
                                ...doc.data(),
                            }
                        }
                    )

                    this.emails = this.users.reduce(
                        (prev, next) => ({ ...prev, [next.userId]: next.email})
                    )

                    this.getCampaigns()
                })
        },
        getCampaigns: function() {
            db
                .collection('drafts')
                .orderBy('created_at','desc')
                .onSnapshot(camp => {
                    this.campaigns = camp.docs.map(
                        (doc, index) => {
                            const data = doc.data()
                            return {
                                ...data,
                                email: this.emails[data.author_id],
                                index,
                                id: doc.id
                            }
                        }
                    )
                })
        },
        select: function (user) {
            this.email = user.email
            this.userId = user.userId
        },
    }
}
</script>

<style scoped>
th {
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
}
td {
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
}
</style>